<template>
    <div class="wrapper">
        <p class="mainContainer__mainTitle mainContainer__mainTitle--mod01">{{ $t('mainContainer.mainTitle') }}</p>

        <div class="mainContainer">
            <div class="mainContainer__box mainContainer__box--mod01">

                <div class="navigation">
                    <router-link class="navigation__link navigation__link--active navigation__link--done"
                        to="/"><span><i class="ri-check-fill"></i></span> {{ $t('mainContainer.stepOne')
                        }}</router-link>
                    <router-link class="navigation__link navigation__link--active navigation__link--done"
                        to="/"><span><i class="ri-check-fill"></i></span> {{ $t('mainContainer.stepTwo')
                        }}</router-link>
                    <router-link class="navigation__link navigation__link--active navigation__link--done" to="/">
                        <span><i class="ri-check-fill"></i></span> {{
                        $t('mainContainer.stepThree') }}</router-link>
                    <router-link class="navigation__link navigation__link--active" to="/">
                        <span><i class="ri-map-pin-line"></i></span> {{
                        $t('mainContainer.stepFour') }}</router-link>
                    <router-link class="navigation__link" to="/"> {{ $t('mainContainer.stepFive') }}</router-link>
                </div>
                <div class="formContainer">
                    <p class="formContainer__infoText">{{
                        $t('getYourQuote.description') }}</p>

                    <div class="formContainer__box">
                        <div class="formContainer__inputBox">
                            <label for="name">{{ $t('getYourQuote.input.nameLabel') }}</label>
                            <input type="text" v-model="name" id="name" inputmode="text"
                                :placeholder="$t('getYourQuote.input.namePlaceholder')" autocomplete="off">
                        </div>
                        <div class="formContainer__inputBox">
                            <label for="telephone">{{ $t('getYourQuote.input.phoneLabel') }}</label>
                            <!-- <input type="tel" :value="rawPhone ? '+' + rawPhone : ''" id="phone"
                                :placeholder="$t('getYourQuote.input.phonePlaceholder')" autocomplete="off" required
                                inputmode="tel" minlength="9" maxlength="20" @input="onInput"> -->
                            <vue-tel-input ref="phoneInputRef" v-model="numberPhone" :default-country="'us'"
                                :only-countries="['us','pr']"
                                :ignored-countries="[]" :show-search-box="true" :show-dial-code="true"
                                :show-flags="true" :auto-format="true" :auto-placeholder="false" :mode="'international'"
                                :input-options="{ placeholder: '+1 (__) -' }" @validate="onPhoneValidate" />
                        </div>
                    </div>
                    <div class="form__consent_box">
                        <div class="consent__checkbox">
                            <label for="consentCheckbox" hidden>{{ $t('getYourQuote.termsCheckboxLabel') }}</label>
                            <input type="checkbox" v-model="consentCheckbox" id="consentCheckbox">
                        </div>
                        <div class="consent_text_box">
                            <p class="consent_title">
                                <b>{{ $t('getYourQuote.termsCheckboxLabel') }}</b>
                            </p>

                            <div class="consent_text" v-html="$t('getYourQuote.terms')">
                            </div>

                        </div>
                    </div>
                    <div class="formContainer__submitBox">
                        <button :disabled="!isValid" class="formContainer__submit" id="continueStep"
                            v-on:click="nextStep">{{ $t('getYourQuote.button')
                            }}</button>
                    </div>
                </div>
            </div>
            <div class="mainContainer__box mainContainer__box--mod02">

                <div class="mainContainer__informationalBox">

                    <p class="infoSection__title infoSection__title--mod01">{{ $t('route_information') }}</p>

                    <div class="informationalBox__infoSection informationalBox__infoSection--mod01">
                        <div class="infoSection__container infoSection__container--33">
                            <p class="infoSection__title">{{ $t('from') }}</p>
                            <p class="infoSection__select" id="selectFrom"> {{ store.state.routeData.fromAddress
                                || '-' }} </p>
                        </div>
                        <div class="infoSection__container infoSection__container--33 infoSection__container--flex">
                            <div class="infoSection__line"></div>
                            <div class="infoSection__miles" id="distanceMiles"> {{
                                store.state.routeData.distanceFromTo + ' MI'
                                }} </div>
                            <div class="infoSection__line"></div>
                        </div>
                        <div class="infoSection__container infoSection__container--33">
                            <p class="infoSection__title infoSection__textAlignRight">{{ $t('to') }}</p>
                            <p class="infoSection__select infoSection__textAlignRight" id="selectTo"> {{
                                store.state.routeData.toAddress || '-' }} </p>
                        </div>
                    </div>

                    <div class="informationalBox__infoSection">
                        <div class="infoSection__container">
                            <p class="infoSection__title">{{ $t('pickupdate') }}</p>
                            <p class="infoSection__select"> {{ store.state.routeData.pickupDate || '-' }} </p>
                        </div>
                        <div class="infoSection__container">
                            <p class="infoSection__title">{{ $t('how_many_veh') }}</p>
                            <p class="infoSection__select"> {{ store.state.routeData.numberOfVehicles || '-' }}
                            </p>
                        </div>
                    </div>

                    <div class="informationalBox__infoSection">
                        <div class="infoSection__container">
                            <p class="infoSection__title" v-if="store.state.routeData.numberOfVehicles == 1">{{
                                $t('transported_vehicule') }}</p>
                            <p class="infoSection__title" v-if="store.state.routeData.numberOfVehicles > 1">{{
                                $t('transported_vehicules') }}</p>
                            <p class="infoSection__select" v-if="store.state.routeData.numberOfVehicles == 1"> {{
                                store.state.vehicleData.vehicleType || '-' }} </p>
                            <p class="infoSection__select" v-if="store.state.routeData.numberOfVehicles > 1">1. {{
                                store.state.vehicleData.vehicleType || '-' }} </p>
                            <p class="infoSection__select" v-if="store.state.routeData.numberOfVehicles > 1">2. {{
                                store.state.vehicleData.vehicleType_2 || '-' }} </p>
                            <p class="infoSection__select" v-if="store.state.routeData.numberOfVehicles > 2">3. {{
                                store.state.vehicleData.vehicleType_3 || '-' }} </p>
                            <p class="infoSection__select" v-if="store.state.routeData.numberOfVehicles > 3">4. {{
                                store.state.vehicleData.vehicleType_4 || '-' }} </p>
                        </div>
                    </div>

                    <div class="informationalBox__infoSection informationalBox__infoSection--mod02">
                        <p class="infoSection__title infoSection__title--mod02"
                            v-if="store.state.routeData.numberOfVehicles == 1">
                            {{ $t("aditional_services") }}
                        </p>
                        <p class="infoSection__title infoSection__title--mod02"
                            v-if="store.state.routeData.numberOfVehicles > 1">
                            {{ $t("aditional_first_veh") }}
                        </p>

                        <div class="informationalBox__infoSection informationalBox__infoSection--mod03">
                            <div class="infoSection__container infoSection__container--33">
                                <p class="infoSection__title infoSection__title--mod03">
                                    {{ $t("runAndDrive") }}
                                </p>
                                <p class="infoSection__select">
                                    {{ store.state.additionalData.vehicleCondition || "-" }}
                                </p>
                            </div>
                            <div class="infoSection__container infoSection__container--33">
                                <p class="infoSection__title infoSection__title--mod03 infoSection__textAlignCenter">
                                    {{ $t("personalObjects") }}
                                </p>
                                <p class="infoSection__select infoSection__textAlignCenter">
                                    {{ store.state.additionalData.vehiclePounds || "-" }} LB
                                </p>
                            </div>
                            <div class="infoSection__container infoSection__container--33">
                                <p class="infoSection__title infoSection__textAlignRight infoSection__title--mod03">
                                    {{ $t("truck_Type") }}
                                </p>
                                <p
                                    class="infoSection__select infoSection__textAlignRight infoSection__textAlignRight--mod01">
                                    {{ store.state.additionalData.vehicleType || "-" }}
                                </p>
                            </div>
                        </div>

                        <p class="infoSection__title infoSection__title--mod02"
                            v-if="store.state.routeData.numberOfVehicles > 1">
                            {{ $t("aditional_second_veh") }}
                        </p>

                        <div class="informationalBox__infoSection informationalBox__infoSection--mod03"
                            v-if="store.state.routeData.numberOfVehicles > 1">
                            <div class="infoSection__container infoSection__container--33">
                                <p class="infoSection__title infoSection__title--mod03">
                                    {{ $t("runAndDrive") }}
                                </p>
                                <p class="infoSection__select">
                                    {{ store.state.additionalData.vehicleCondition_2 || "-" }}
                                </p>
                            </div>
                            <div class="infoSection__container infoSection__container--33">
                                <p class="infoSection__title infoSection__title--mod03 infoSection__textAlignCenter">
                                    {{ $t("personalObjects") }}
                                </p>
                                <p class="infoSection__select infoSection__textAlignCenter">
                                    {{ store.state.additionalData.vehiclePounds_2 || "-" }} LB
                                </p>
                            </div>
                            <div class="infoSection__container infoSection__container--33">
                                <p class="infoSection__title infoSection__textAlignRight infoSection__title--mod03">
                                    {{ $t("truck_Type") }}
                                </p>
                                <p
                                    class="infoSection__select infoSection__textAlignRight infoSection__textAlignRight--mod01">
                                    {{ store.state.additionalData.vehicleType_2 || "-" }}
                                </p>
                            </div>
                        </div>

                        <p class="infoSection__title infoSection__title--mod02"
                            v-if="store.state.routeData.numberOfVehicles > 2">
                            {{ $t("aditional_third_veh") }}
                        </p>

                        <div class="informationalBox__infoSection informationalBox__infoSection--mod03"
                            v-if="store.state.routeData.numberOfVehicles > 2">
                            <div class="infoSection__container infoSection__container--33">
                                <p class="infoSection__title infoSection__title--mod03">
                                    {{ $t("runAndDrive") }}
                                </p>
                                <p class="infoSection__select">
                                    {{ store.state.additionalData.vehicleCondition_3 || "-" }}
                                </p>
                            </div>
                            <div class="infoSection__container infoSection__container--33">
                                <p class="infoSection__title infoSection__title--mod03 infoSection__textAlignCenter">
                                    {{ $t("personalObjects") }}
                                </p>
                                <p class="infoSection__select infoSection__textAlignCenter">
                                    {{ store.state.additionalData.vehiclePounds_3 || "-" }} LB
                                </p>
                            </div>
                            <div class="infoSection__container infoSection__container--33">
                                <p class="infoSection__title infoSection__textAlignRight infoSection__title--mod03">
                                    {{ $t("truck_Type") }}
                                </p>
                                <p
                                    class="infoSection__select infoSection__textAlignRight infoSection__textAlignRight--mod01">
                                    {{ store.state.additionalData.vehicleType_3 || "-" }}
                                </p>
                            </div>
                        </div>

                        <p class="infoSection__title infoSection__title--mod02"
                            v-if="store.state.routeData.numberOfVehicles > 3">
                            {{ $t("aditional_fourth_veh") }}
                        </p>

                        <div class="informationalBox__infoSection informationalBox__infoSection--mod03"
                            v-if="store.state.routeData.numberOfVehicles > 3">
                            <div class="infoSection__container infoSection__container--33">
                                <p class="infoSection__title infoSection__title--mod03">
                                    {{ $t("runAndDrive") }}
                                </p>
                                <p class="infoSection__select">
                                    {{ store.state.additionalData.vehicleCondition_4 || "-" }}
                                </p>
                            </div>
                            <div class="infoSection__container infoSection__container--33">
                                <p class="infoSection__title infoSection__title--mod03 infoSection__textAlignCenter">
                                    {{ $t("personalObjects") }}
                                </p>
                                <p class="infoSection__select infoSection__textAlignCenter">
                                    {{ store.state.additionalData.vehiclePounds_4 || "-" }} LB
                                </p>
                            </div>
                            <div class="infoSection__container infoSection__container--33">
                                <p class="infoSection__title infoSection__textAlignRight infoSection__title--mod03">
                                    {{ $t("truck_Type") }}
                                </p>
                                <p
                                    class="infoSection__select infoSection__textAlignRight infoSection__textAlignRight--mod01">
                                    {{ store.state.additionalData.vehicleType_4 || "-" }}
                                </p>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</template>
<script setup>
// import axios from 'axios';
import { ref, watchEffect, watch, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { VueTelInput } from 'vue-tel-input';
import './css/vue-tel-input.css';
import store from './../../store';

const route = useRoute()
const router = useRouter()

const redirectTo = route.query.redirectTo || '/'

const numberPhone = ref(null)

const fullPhoneNumber = ref("+1 ")
const name = ref("");
const isPhoneValid = ref(false)
const consentCheckbox = ref(false);
const phoneInputRef = ref(null);
const isValid = ref(false);

watchEffect(() => {
    isValid.value =
        name.value.trim().length > 0 &&
        isPhoneValid.value &&
        consentCheckbox.value
})

// Simplificar el watcher para solo debuggear
watch(numberPhone, (newValue) => {
    console.log('numberPhone changed:', newValue);
}, { deep: true })


const nextStep = async () => {
    store.dispatch('SAVE_GET_YOUR_QUOTE_ACTION', {
        name: name.value,
        phone: fullPhoneNumber.value,
        consent: consentCheckbox.value,
    })

    router.replace({ name: redirectTo });
}

// Función para manejar la validación del teléfono
function onPhoneValidate(phoneObject) {
    console.log('Phone validate event - Full object:', phoneObject);
    
    // El evento @validate de vue-tel-input pasa un objeto con toda la información
    if (phoneObject) {
        // Actualizar el estado de validez
        isPhoneValid.value = phoneObject.valid || false;
        
        // Actualizar el número completo
        if (phoneObject.number) {
            fullPhoneNumber.value = phoneObject.number;
        } else if (phoneObject.nationalNumber && phoneObject.countryCallingCode) {
            fullPhoneNumber.value = `+${phoneObject.countryCallingCode}${phoneObject.nationalNumber}`;
        } else {
            fullPhoneNumber.value = '';
        }
        
        // Debug completo
        console.log('Phone validation result:', {
            isValid: phoneObject.valid,
            number: phoneObject.number,
            nationalNumber: phoneObject.nationalNumber,
            countryCallingCode: phoneObject.countryCallingCode,
            country: phoneObject.country,
            fullPhoneNumber: fullPhoneNumber.value
        });
    }
}

onMounted(() => {
    // Inicializar con valores por defecto
    fullPhoneNumber.value = '+1';
    isPhoneValid.value = false;
});

</script>

<style scoped>
.formContainer__infoText {
    width: 90%;
}

.form__center {
    gap: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.formContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.formContainer__inputBox {
    padding: 0;
    margin: 0;
}

.formContainer__box {
    width: 90%;
    margin-top: 3rem;
    display: flex;
    gap: 1rem;
    justify-content: space-between;
}

.form__consent_box {
    display: flex;
    flex-direction: row !important;
    align-items: flex-start;
    gap: 1rem;
    justify-content: center;
    width: 75%;
    margin-top: 3rem;
}

.consent_text_box {
    font-size: 12px;
    color: #757575;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    line-height: 1.2;
    gap: 0.2rem;
}

.consent_link {
    color: #757575 !important;
    text-decoration: underline;
    cursor: pointer;
}

.consent_title {
    color: var(--SecondaryColor);
    font-size: 14px;
    padding: 0;
    margin: 0;
}

input[type='checkbox']:disabled {
    cursor: not-allowed;
    /* color: var(--SecondaryColor); */
    border: 0.15em solid var(--ComplementaryColor01) !important;

}

input[type='checkbox']::before {
    display: flex;
    place-content: center;
    place-items: center;
    content: '';
    width: 0.70em;
    height: 0.70em;
    border-radius: 25%;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
    background-color: var(--SecondaryColor);
}

input[type='checkbox']:checked::before {
    transform: scale(1);
}

input[type='checkbox']:focus {
    /* outline: max(2px, 0.15em) solid var(--SecondaryColor); */
    outline-offset: max(2px, 0.15em);
}

input[type='checkbox'] {
    appearance: none;
    -webkit-appearance: none;
    background-color: #ffffff;
    margin: 0;
    font: inherit;
    color: var(--SecondaryColor);
    width: 1.15em;
    height: 1.15em;
    border: 0.15em solid var(--SecondaryColor);
    border-radius: 25%;
    display: grid;
    place-content: center;
    justify-self: center;
    cursor: pointer;
    transition: all 0.2s ease;
}

@media (max-width: 768px) {
    .formContainer__box {
        flex-direction: column;
        width: 90%;
    }

    .formContainer__inputBox {
        flex-direction: row;
        width: auto;
        justify-content: space-between;
        align-items: center;
    }

    .formContainer__inputBox input, .vue-tel-input {
        width: 60%;
    }

    .formContainer__inputBox label {
        text-wrap: nowrap;
    }

    .form__consent_box {
        width: 90%;
    }

    .consent_text_box {
        padding-top: 2.1px;
    }

    .formContainer__submit {
        padding: 17px 52px;
    }

}
</style>